import React from "react";

export interface SpinnerProps {
 size?: "sm" | "md" | "lg";
 className?: string;
}

const sizeClasses = {
 sm: "h-4 w-4",
 md: "h-8 w-8",
 lg: "h-12 w-12",
};

export const Spinner: React.FC<SpinnerProps> = ({
 size = "md",
 className = "",
}) => {
  return (
   <svg
    className={`animate-spin text-blue-600 ${sizeClasses[size]} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
   >
   <circle
    className="opacity-25"
    cx="12"
    cy="12"
    r="10"
    stroke="currentColor"
    strokeWidth="4"
   />
   <circle
    className="opacity-75"
    cx="12"
    cy="12"
    r="10"
    stroke="currentColor"
    strokeWidth="4"
    strokeLinecap="round"
    strokeDasharray="60"
    strokeDashoffset="45"
   />
  </svg>
 );
};

export default Spinner;

